import { createAction } from '../../../utils/redux/createAction';

const actionsScope = 'profile/google-fit-modal';

export const GOOGLE_FIT_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const googleFitModalActions = {
  open: createAction(GOOGLE_FIT_MODAL.OPEN),
  close: createAction(GOOGLE_FIT_MODAL.CLOSE),
};

const initialState = {
  opened: false,
};

export default (state = initialState, { type }) => {
  switch (type) {
    case GOOGLE_FIT_MODAL.OPEN: {
      return {
        ...state,
        opened: true,
      };
    }

    case GOOGLE_FIT_MODAL.CLOSE: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/profiles/patientHealthboard/google-fit-modal.js